import { render, staticRenderFns } from "./minimumActivity.vue?vue&type=template&id=3642c9ce&scoped=true&lang=pug&"
import script from "./minimumActivity.vue?vue&type=script&lang=js&"
export * from "./minimumActivity.vue?vue&type=script&lang=js&"
import style0 from "./minimumActivity.vue?vue&type=style&index=0&id=3642c9ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642c9ce",
  null
  
)

export default component.exports